import { ref, type Ref } from 'vue';
import { useCustomToast } from '@/shared/lib';
import { trainingApi } from '@/entities/Training';

export const INSTRUCTOR_CURRICULUM_VIEW_ERROR_MESSAGE =
  'Erro ao acessar o currículo. Tente novamente';

export function useInstructorCurriculumViewer(): {
  openingSessionIds: Ref<number[]>;
  openCurriculum: (sessionId: number) => Promise<void>;
} {
  const { showErrorToast } = useCustomToast();
  const openingSessionIds = ref<number[]>([]);

  const openCurriculum = async (sessionId: number) => {
    if (openingSessionIds.value.includes(sessionId)) {
      return;
    }

    const pendingTab = window.open('', '_blank');
    if (pendingTab) {
      pendingTab.opener = null;
    }

    openingSessionIds.value = [...openingSessionIds.value, sessionId];

    try {
      const blob = await trainingApi.getInstructorCurriculumFile(sessionId);
      const blobUrl = URL.createObjectURL(blob);

      if (pendingTab) {
        pendingTab.location.href = blobUrl;
      } else {
        window.open(blobUrl, '_blank', 'noopener');
      }

      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    } catch {
      pendingTab?.close();
      showErrorToast(
        { title: INSTRUCTOR_CURRICULUM_VIEW_ERROR_MESSAGE, type: 'error' },
        { timeout: false, closeButton: true }
      );
    } finally {
      openingSessionIds.value = openingSessionIds.value.filter((id) => id !== sessionId);
    }
  };

  return { openingSessionIds, openCurriculum };
}
